export default __webpack_public_path__ + "4eb13b5.png";